
import * as jose from 'jose'
import { baseUrl } from "../../helpers/baseUrl";

export const logoutKeycloak = async (token) => {

    const { sub } = jose.decodeJwt(token);

    const raw = JSON.stringify({
        "sub": sub
    });

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: raw,
        redirect: "follow",
        credentials: 'include'
    };

    try {
        const resp = await fetch(`${baseUrl('APP_SERVER_URL')}/api/logout`, requestOptions)

        if (resp.ok) {
            resp.data = await resp.json()
            console.log("logoutKeycloak ::", resp.data);
        }

    } catch (error) {
        console.log(error);
    };
}